import * as actionTypes from './../Audit_action.types';
import * as api from './../audit_api_services/Audit.api';

export const getUnitWiseVendorRequest = (client_id) => ({
  type: actionTypes.GET_UNIT_BASE_VENDOR_REQUEST,
  payload:client_id
});

export const getUnitWiseVendorSuccess = (clients) => ({
type: actionTypes.GET_UNIT_BASE_VENDOR_SUCCESS,
payload: clients,
});

export const getUnitWiseVendorFailure = (error) => ({
type: actionTypes.GET_UNIT_BASE_VENDOR_FAILURE,
payload: error,
});

export const getUnitWiseVendor = (client_id) => {
return async (dispatch) => {
  dispatch(getUnitWiseVendorRequest(client_id));
  try {
    const response = await api.get_client_unit_base_vendor(client_id);
    dispatch(getUnitWiseVendorSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(getUnitWiseVendorFailure(error));
    return { success: false, message: error };
  }
};
};
export const getAuditRequest = (client_id) => ({
    type: actionTypes.GET_AUDIT_REQUEST,
    payload:client_id
});

export const getAuditSuccess = (clients) => ({
  type: actionTypes.GET_AUDIT_SUCCESS,
  payload: clients,
});

export const getAuditFailure = (error) => ({
  type: actionTypes.GET_AUDIT_FAILURE,
  payload: error,
});

export const getAudit = (client_id) => {
  return async (dispatch) => {
    dispatch(getAuditRequest(client_id));
    try {
      const response = await api.getAudit(client_id);
      dispatch(getAuditSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getAuditFailure(error));
      return { success: false, message: error };
    }
  };
};
export const createSingleAuditRequest = (data) => ({
    type: actionTypes.GET_UNIT_BASE_VENDOR_REQUEST,
    payload: data,
});

export const createSingleAuditSuccess = (data) => ({
  type: actionTypes.GET_UNIT_BASE_VENDOR_SUCCESS,
  payload: data,
});

export const createSingleAuditFailure = (error) => ({
  type: actionTypes.GET_UNIT_BASE_VENDOR_FAILURE,
  payload: error,
});

export const createSingleAuditData = (data) => {
  return async (dispatch) => {
    dispatch(createSingleAuditRequest(data));
    try {
      const response = await api.createSingleAudit(data);
      dispatch(createSingleAuditSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(createSingleAuditFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getClientWiseAuditRequest = (client_id) => ({
  type: actionTypes.GET_CLIENT_WISE_AUDIT_REQUEST,
  payload:client_id
});

export const getClientWiseAuditSuccess = (clients) => ({
type: actionTypes.GET_CLIENT_WISE_AUDIT_SUCCESS,
payload: clients,
});

export const getClientWiseAuditFailure = (error) => ({
type: actionTypes.GET_CLIENT_WISE_AUDIT_FAILURE,
payload: error,
});

export const getClientWiseAudit = (client_id) => {
return async (dispatch) => {
  dispatch(getClientWiseAuditRequest(client_id));
  try {
    const response = await api.get_client_wise_audit(client_id);
    dispatch(getClientWiseAuditSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(getClientWiseAuditFailure(error));
    return { success: false, message: error };
  }
};
};

export const getAuditDetailsRequest = (client_id) => ({
  type: actionTypes.GET_AUDIT_DETAILS_REQUEST,
  payload:client_id
});

export const getAuditDetailsSuccess = (clients) => ({
type: actionTypes.GET_AUDIT_DETAILS_SUCCESS,
payload: clients,
});

export const getAuditDetailsFailure = (error) => ({
type: actionTypes.GET_AUDIT_DETAILS_FAILURE,
payload: error,
});

export const getAuditDetails = (id) => {
return async (dispatch) => {
  dispatch(getAuditDetailsRequest(id));
  try {
    const response = await api.getAuditDetails(id);
    dispatch(getAuditDetailsSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(getAuditDetailsFailure(error));
    return { success: false, message: error };
  }
};
};
export const updateAuditDetailsRequest = (data) => ({
  type: actionTypes.UPDATE_AUDIT_DETAILS_REQUEST,
  payload: data,
});

export const updateAuditDetailsSuccess = (data) => ({
type: actionTypes.UPDATE_AUDIT_DETAILS_SUCCESS,
payload: data,
});

export const updateAuditDetailsFailure = (error) => ({
type: actionTypes.UPDATE_AUDIT_DETAILS_FAILURE,
payload: error,
});

export const updateAuditDetails = (status,data) => {
  return async (dispatch) => {
    dispatch(updateAuditDetailsRequest(data));
    try {
      const response = await api.updateAudit(status,data);
      dispatch(updateAuditDetailsSuccess(response));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateAuditDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};

export const updateExtandAuditRequest = (id,data) => ({
  type: actionTypes.UPDATE_AUDIT_DETAILS_REQUEST,
  payload: id,data,
});

export const updateExtandAuditSuccess = (data) => ({
type: actionTypes.UPDATE_AUDIT_DETAILS_SUCCESS,
payload: data,
});

export const updateExtandAuditFailure = (error) => ({
type: actionTypes.UPDATE_AUDIT_DETAILS_FAILURE,
payload: error,
});

export const extandAudit = (id,data) => {
  return async (dispatch) => {
    dispatch(updateAuditDetailsRequest(id,data));
    try {
      const response = await api.extendAudit(id,data);
      dispatch(updateAuditDetailsSuccess(response));
      return { success: true, message: response.message };
    } catch (error) {
      dispatch(updateAuditDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getlatestAuditRequest = (client_id) => ({
  type: actionTypes.GET_AUDIT_REQUEST,
  payload:client_id
});

export const getlatestAuditSuccess = (clients) => ({
type: actionTypes.GET_AUDIT_SUCCESS,
payload: clients,
});

export const getlatestAuditFailure = (error) => ({
type: actionTypes.GET_AUDIT_FAILURE,
payload: error,
});

export const getlatestAudit = (client_id) => {
return async (dispatch) => {
  dispatch(getlatestAuditRequest(client_id));
  try {
    const response = await api.getlatestAudit(client_id);
    dispatch(getlatestAuditSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(getlatestAuditFailure(error));
    return { success: false, message: error };
  }
};
};


export const filteredAuditRequest = (client_id) => ({
  type: actionTypes.GET_AUDIT_REQUEST,
  payload:client_id
});

export const filteredAuditSuccess = (clients) => ({
type: actionTypes.GET_AUDIT_SUCCESS,
payload: clients,
});

export const filteredAuditFailure = (error) => ({
type: actionTypes.GET_AUDIT_FAILURE,
payload: error,
});

export const filteredAudit = (client_id,fromMonth,toMonth) => {
return async (dispatch) => {
  dispatch(filteredAuditRequest(client_id));
  try {
    const response = await api.filteredAudit(client_id,fromMonth,toMonth);
    dispatch(filteredAuditSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(filteredAuditFailure(error));
    return { success: false, message: error };
  }
};
};

export const filteredAuditDetailsRequest = (client_id) => ({
    type: actionTypes.GET_AUDIT_REQUEST,
    payload:client_id
});

export const filteredAuditDetailsSuccess = (clients) => ({
  type: actionTypes.GET_AUDIT_SUCCESS,
  payload: clients,
});

export const filteredAuditDetailsFailure = (error) => ({
  type: actionTypes.GET_AUDIT_FAILURE,
  payload: error,
});

export const filteredAuditDetails = (client_id,fromMonth,toMonth) => {
  return async (dispatch) => {
    dispatch(filteredAuditDetailsRequest(client_id));
    try {
      const response = await api.filteredAuditDetails(client_id,fromMonth,toMonth);
      dispatch(filteredAuditDetailsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(filteredAuditDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getLatestAuditDetailsRequest = (client_id) => ({
  type: actionTypes.GET_CLIENT_WISE_AUDIT_REQUEST,
  payload:client_id
});

export const getLatestAuditDetailsSuccess = (clients) => ({
type: actionTypes.GET_CLIENT_WISE_AUDIT_SUCCESS,
payload: clients,
});

export const getLatestAuditDetailsFailure = (error) => ({
type: actionTypes.GET_CLIENT_WISE_AUDIT_FAILURE,
payload: error,
});

export const latestAuditDetails = (client_id) => {
return async (dispatch) => {
  dispatch(getLatestAuditDetailsSuccess(client_id));
  try {
    const response = await api.latestAuditDetailsData(client_id);
    dispatch(getClientWiseAuditSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(getLatestAuditDetailsFailure(error));
    return { success: false, message: error };
  }
};
};

export const downloadAuditDetailsRequest = () => ({
  type: actionTypes.DOWNLOAD_AUDIT_REQUEST,
});

export const downloadAuditDetailsSuccess = (clients) => ({
  type: actionTypes.DOWNLOAD_AUDIT_SUCCESS,
  payload: clients,
});

export const downloadAuditDetailsFailure = (error) => ({
  type: actionTypes.DOWNLOAD_AUDIT_FAILURE,
  payload: error,
});

export const downloadAuditDetailsdata = (data) => {
  return async (dispatch) => {
    dispatch(downloadAuditDetailsRequest());
    try {
      const response = await api.downloadAuditDetails(data);
      dispatch(downloadAuditDetailsSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(downloadAuditDetailsFailure(error));
      return { success: false, message: error };
    }
  };
};


export const getAuditReportRequest = (data) => ({
  type: actionTypes.GET_UNIT_BASE_VENDOR_REQUEST,
  payload:data
});

export const getAuditReportSuccess = (data) => ({
type: actionTypes.GET_UNIT_BASE_VENDOR_SUCCESS,
payload: data,
});

export const getAuditReportFailure = (error) => ({
type: actionTypes.GET_UNIT_BASE_VENDOR_FAILURE,
payload: error,
});

export const getAuditReport = (data) => {
  return async (dispatch) => {
    dispatch(getAuditReportRequest(data));
    try {
      const response = await api.get_audit_report(data);
      dispatch(getAuditReportSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getAuditReportFailure(error));
      return { success: false, message: error };
    }
  };
};
export const getdownloadAllSelectedReportRequest = (data) => ({
  type: actionTypes.GET_UNIT_BASE_VENDOR_REQUEST,
  payload:data
});

export const getdownloadAllSelectedReportSuccess = (data) => ({
type: actionTypes.GET_UNIT_BASE_VENDOR_SUCCESS,
payload: data,
});

export const getdownloadAllSelectedReportFailure = (error) => ({
type: actionTypes.GET_UNIT_BASE_VENDOR_FAILURE,
payload: error,
});

export const downloadAllSelectedReport = (data) => {
  return async (dispatch) => {
    dispatch(getdownloadAllSelectedReportRequest(data));
    try {
      const response = await api.download_all_selected_report(data);
      dispatch(getdownloadAllSelectedReportSuccess(response));
      return { success: true, data: response };
    } catch (error) {
      dispatch(getdownloadAllSelectedReportFailure(error));
      return { success: false, message: error };
    }
  };
};


export const auditReportFilterHeaderRequest = (client_id) => ({
  type: actionTypes.GET_AUDIT_REQUEST,
  payload:client_id
});

export const auditReportFilterHeaderSuccess = (clients) => ({
type: actionTypes.GET_AUDIT_SUCCESS,
payload: clients,
});

export const auditReportFilterHeaderFailure = (error) => ({
type: actionTypes.GET_AUDIT_FAILURE,
payload: error,
});

export const auditReportFilterHeader = (client_id,fromMonth,toMonth) => {
return async (dispatch) => {
  dispatch(auditReportFilterHeaderRequest(client_id));
  try {
    const response = await api.auditReportFilterHeader(client_id,fromMonth,toMonth);
    dispatch(auditReportFilterHeaderSuccess(response));
    return { success: true, data: response };
  } catch (error) {
    dispatch(auditReportFilterHeaderFailure(error));
    return { success: false, message: error };
  }
};
};